import { formatApiError } from "./api";

export async function downloadPdf(url, filename, headers) {
  const response = await fetch(url, { headers });
  if (!response.ok) {
    const body = await response.json().catch(() => null);
    throw new Error(body?.detail ? formatApiError(body.detail) : "Documento non disponibile. Riprova o contatta il supporto.");
  }
  if (response.headers.get("content-type")?.split(";")[0].trim().toLowerCase() !== "application/pdf") {
    throw new Error("Il server non ha restituito un PDF valido. Riprova o contatta il supporto.");
  }
  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  try {
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = filename;
    link.click();
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
}
